import React, { useState } from "react";

import "./solLoading.css";

const QUANTIDADE_RAIOS = 12;
const CICLO_SEGUNDOS = 1.8;

let contadorInstancias = 0;

/**
 * Indicador de carregamento do OiSol: o sol do logo com núcleo pulsando,
 * raios-pétala girando e o anel de pessoas acendendo em sequência.
 * Registrado como indicador padrão do antd em App.js (Spin.setDefaultIndicator),
 * por isso aceita className/style, que o Spin repassa ao clonar o elemento.
 */
export const SolLoading = ({ className = "", style }) => {
  // Cada instância precisa de um id próprio para o gradiente do núcleo
  const [gradienteId] = useState(() => `sol-loading-gradiente-${++contadorInstancias}`);

  const raios = Array.from({ length: QUANTIDADE_RAIOS }, (_, indice) => ({
    indice,
    atraso: `${(-(CICLO_SEGUNDOS / QUANTIDADE_RAIOS) * indice).toFixed(2)}s`,
  }));

  return (
    <span className={`sol-loading ${className}`.trim()} style={style}>
      <svg viewBox="0 0 100 100" role="img" aria-label="Carregando">
        <defs>
          <radialGradient id={gradienteId} cx="40%" cy="38%" r="70%">
            <stop offset="0" stopColor="#ffd08a" />
            <stop offset=".55" stopColor="#ff8a1f" />
            <stop offset="1" stopColor="#fe6a00" />
          </radialGradient>
        </defs>

        <g>
          {raios.map(({ indice, atraso }) => (
            <g key={indice} transform={`rotate(${indice * 30 + 15} 50 50)`}>
              <circle
                className="sol-loading__pessoa"
                style={{ animationDelay: atraso }}
                cx="50"
                cy="5.5"
                r="3.6"
                fill="#ff8a1f"
              />
            </g>
          ))}
        </g>

        <g className="sol-loading__raios">
          {raios.map(({ indice, atraso }) => (
            <g key={indice} transform={`rotate(${indice * 30} 50 50)`}>
              <path
                className="sol-loading__petala"
                style={{ animationDelay: atraso }}
                fill={indice % 2 ? "#ff9a3c" : "#fe6a00"}
                d="M50 13 C56 20 56.5 27 50 33 C43.5 27 44 20 50 13 Z"
              />
            </g>
          ))}
        </g>

        <circle className="sol-loading__halo" cx="50" cy="50" r="21" fill="#ffb15c" />
        <circle
          className="sol-loading__nucleo"
          cx="50"
          cy="50"
          r="17"
          fill={`url(#${gradienteId})`}
        />
      </svg>
    </span>
  );
};
